export const SETTINGS_DCMHEADER = 'exportAs';
export const SETTINGS_OVERLAY = 'overlay';
export const SETTINGS_MEASUREMENT = 'measurement';
export const SETTINGS_FSVIEW = 'fsView';
export const SETTINGS_DICOMDIRVIEW = 'dicomdirView';
